import { render, staticRenderFns } from "./RegisterSubModule.vue?vue&type=template&id=57246bda&scoped=true&"
import script from "./RegisterSubModule.vue?vue&type=script&lang=js&"
export * from "./RegisterSubModule.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSubModule.vue?vue&type=style&index=0&id=57246bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57246bda",
  null
  
)

export default component.exports